<template>
    <div class="bottom-navbar-wrapper">

        <div class="bottom-navbar">

            <!-- Home -->
            <button
                class="nav-item"
                :class="{ active: isActive('/Home') }"
                @click="goTo('/Home')"
            >
                <div class="nav-icon-wrapper">
                    <i class="fi fi-rr-home"></i>
                </div>

                <span>דף ראשי</span>
            </button>

            <!-- Orders -->
            <button
                class="nav-item"
                :class="{ active: isActive('/ordersBeta') }"
                @click="goTo('/ordersBeta')"
            >
                <div class="nav-icon-wrapper">
                    <i class="fi fi-rr-shopping-bag"></i>
                </div>

                <span>הזמנות</span>
            </button>

            <!-- Add -->
            <!-- <button
                class="nav-item add-button"
                :class="{ active: isActive('/new-order') }"
                @click="goTo('/new-order')"
            >
                <div class="add-circle">
                    <i class="fi fi-rr-plus"></i>
                </div>
            </button> -->

            <!-- Reports -->
            <button
                class="nav-item"
                :class="{ active: isActive('/cheques') }"
                @click="goTo('/cheques')"
            >
                <div class="nav-icon-wrapper">
                    <i class="fi fi-rr-payroll-calendar"></i>
                </div>

                <span>שיקים</span>
            </button>

            <!-- Profile -->
            <button
                class="nav-item"
                :class="{ active: isActive('/profile') }"
                @click="goTo('/profile')"
            >
                <div class="nav-icon-wrapper">
                    <i class="fi fi-rr-user"></i>
                </div>

                <span>חשבון</span>
            </button>

        </div>

    </div>
</template>

<script>
export default {

    name: 'BottomNavbar',

    methods: {

        goTo(route) {

            if (this.$route.path !== route) {
                this.$router.push(route)
            }

        },

        isActive(route) {
            return this.$route.path === route
        }

    }

}
</script>

<style scoped> 
.bottom-navbar-wrapper{
    display: none;
}
@media (max-width: 480px) {
.bottom-navbar-wrapper {

    position: fixed;

    left: 0;
    bottom: 0;

    width: 100%;

    display: flex;
    justify-content: center;

    z-index: 9999;

    pointer-events: none;

}

.bottom-navbar {

    pointer-events: auto;

    width: calc(100% - 24px);
    max-width: 520px;

    margin-bottom: 14px;

    padding:
        10px
        14px
        calc(env(safe-area-inset-bottom) + 10px)
        14px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    border-radius: 32px;

    background:
        rgba(255, 255, 255, 0.82);

    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);

    border:
        1px solid rgba(255,255,255,0.35);

    box-shadow:
        0 8px 30px rgba(0,0,0,0.08),
        0 2px 10px rgba(0,0,0,0.03);

}

.nav-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: none;
    outline: none;
    background: transparent;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    transition:
        transform .22s ease,
        background .22s ease,
        color .22s ease,
        box-shadow .22s ease;

    color: #777;

}

.nav-item:active {

    transform: scale(0.92);

}

.nav-icon-wrapper {

    width: 34px;
    height: 34px;

    display: flex;
    align-items: center;
    justify-content: center;

}

.nav-item i {

    font-size: 24px;

    transition:
        transform .22s ease,
        color .22s ease;

}

.nav-item span {

    font-size: 11px;
    font-weight: 600;

    white-space: nowrap;

}

/* ACTIVE */

.nav-item.active {

    background:
        rgba(255,255,255,0.55);

    color: #111;


    box-shadow:
        0 4px 16px rgba(0,0,0,0.06);

}

.nav-item.active i {

    transform: scale(1);

}

/* CENTER BUTTON */

.add-button {

    transform: translateY(-18px);

}

.add-button.active {

    background: transparent;
    box-shadow: none;

}

.add-circle {

    width: 58px;
    height: 58px;

    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    background: linear-gradient(
        135deg,
        #111,
        #2b2b2b
    );

    box-shadow:
        0 10px 25px rgba(0,0,0,0.18);

    transition:
        transform .25s ease,
        box-shadow .25s ease;

}

.add-circle i {

    color: white;

    font-size: 24px;

}

.add-button:active .add-circle {

    transform: scale(0.92);

}

.add-button.active .add-circle {

    transform: scale(1.08);

}

/* DARK MODE */

.dark-theme .bottom-navbar {

    background:
        rgba(18,18,18,0.75);

    border:
        1px solid rgba(255,255,255,0.06);

}

.dark-theme .nav-item {

    color: #aaa;

}

.dark-theme .nav-item.active {

    background:
        rgba(255,255,255,0.08);

    color: white;

}

/* RESPONSIVE */



    .bottom-navbar {

        width: calc(100% - 16px);

        padding-left: 10px;
        padding-right: 10px;

    }

    .nav-item {

        width: 58px;
        height: 58px;

    }

    .nav-item i {

        font-size: 20px;

    }

    .nav-item span {
        font-family: "Noto Sans Hebrew";
        font-size: 11px;

    }

}

</style>


// WEBPACK FOOTER //
// src/components/BottomNavbar.vue